/* @flow */

import React from 'react';
import Footer from './footer';

export default class NotFound extends React.Component {
  render(): ?React.Element<any> {
    return (
      <div id="not-found">
        <h1>Oops, page not found</h1>
        <p>Think this page should be here? <a href='mailto:maps@calpoly.edu' target='_blank'>Contact us.</a></p>
        <Footer />
      </div>
    );
  }
}
